import imageAPI from '../../../../../assets/img/imageAPI.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleCheck,
  faXmarkCircle
} from '@fortawesome/free-solid-svg-icons';
import { Card, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { getKeys } from 'redux/apiKeysSlice';

const WidgetAPI = () => {
  // * States
  const dispatch = useDispatch();
  const apiKeyArray = useSelector(state => state.apiKeys.keys);
  const { data } = useSelector(state => state.realEstate);
  const [loading, setLoading] = useState(false);

  // * Methods
  const FetchData = async () => {
    setLoading(true);
    await dispatch(getKeys(data.userId));
    setLoading(false);
  };

  // * Life Cycle
  useEffect(() => {
    Object.keys(data).length && FetchData();
  }, [data]);

  return (
    <>
      <Card className="bg-white h-100">
        <Card.Body>
          {loading ? (
            <div className="d-flex justify-content-center align-items-center">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <div className="d-flex align-items-center" style={{ gap: 25 }}>
              <FontAwesomeIcon
                icon={apiKeyArray.length ? faCircleCheck : faXmarkCircle}
                color={apiKeyArray.length ? '#2c7be5' : 'red'}
                className="position-absolute top-0 end-0 mt-3 me-3"
              />
              <div style={{ maxWidth: 60 }}>
                <img
                  src={imageAPI}
                  alt="API"
                  style={{
                    objectFit: 'contain'
                  }}
                  className="w-100 h-100"
                />
              </div>
              {apiKeyArray.length ? (
                <div className="w-100 d-flex flex-column">
                  <div className="w-100 d-flex justify-content-between">
                    <h5 className="text-black">Claves de Integración</h5>
                  </div>
                  <div>
                    {apiKeyArray.map(apikey => (
                      <div key={apikey.apiKey}>
                        <p className="m-0" style={{ color: '#2c7be5' }}>
                          {apikey.name}
                        </p>
                        <p className="mb-2">{`${apikey.apiKey.slice(
                          0,
                          15
                        )}...`}</p>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="w-100 d-flex flex-column">
                  <div className="w-100 d-flex justify-content-between align-items-center">
                    <h5 className="text-black mb-0">
                      No hay claves de integración creadas
                    </h5>
                  </div>
                </div>
              )}
            </div>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default WidgetAPI;
